import { defineSlotRecipe } from "@pandacss/dev";
import {
  baseInputTrigger,
  mediumInputTigger,
  smallInputTigger,
} from "./utils/inputTrigger";

export const aromaDatepickerInput = defineSlotRecipe({
  className: "aroma-input",
  jsx: ["Input", "DatePicker"],
  slots: ["rangeContainer", "trigger"],
  base: {
    rangeContainer: {
      flexDirection: "row",
      gap: "gap.2",
      alignItems: "center",
    },
    trigger: baseInputTrigger,
  },
  variants: {
    size: {
      small: {
        trigger: smallInputTigger,
      },
      medium: {
        trigger: mediumInputTigger,
      },
    },
    inblock: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      inblock: true,
      css: {
        rangeContainer: {
          flexDirection: "column",
        },
      },
    },
  ],
  defaultVariants: { size: "small", inblock: false },
});
